<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true" 
            scrollable 
            centered 
            size="md"  
            @hide="this.emitEventCancel"
            @ok="this.emitEventOK"
            :id="DialogModalId" 
            :title="$t('AuditSettingEdit.Title')"  
            style="padding:none!important" 
            :cancel-title="$t('Shared.BtnCancel')"
            :ok-title="$t('Shared.Save')" 
        >
            <MdTitle v-bind:Text="moduleName" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <div class="row" v-if="value">
                <div class="col-md-6" v-if="!isAuthentication">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.Add')"
                        v-bind:Name="value.recId+'checkbox-insert'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditInsert"
                    />
                </div>
                <div class="col-md-6" v-if="!isAuthentication">
                    <MdCheckBox
                        v-bind:Label="$t('AuditSettingsList.Update')"
                        v-bind:Name="value.recId+'checkbox-update'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditUpdate"
                    />
                </div>
                <div class="col-md-6" v-if="!isAuthentication">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.TitleDelete')"
                        v-bind:Name="value.recId+'checkbox-delete'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditDelete"
                    />
                </div>
                <div class="col-md-6" v-if="isViewVisible">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.View')"
                        v-bind:Name="value.recId+'checkbox-view'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditView"
                    />
                </div>
                <div class="col-md-6" v-if="isAuthentication">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.LoginTitle')"
                        v-bind:Name="value.recId+'checkbox-login'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditLogin"
                    />
                </div>
                <div class="col-md-6" v-if="isAuthentication">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.Logout')"
                        v-bind:Name="value.recId+'checkbox-logout'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="value.auditLogout"
                    />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js' 

export default {
    name: 'AuditSettingEditDialog',
    mixins: [ShowMessage],

    props: {
        VisibleDialog:Boolean,
        value: Object
    },

    data() {
        return {
            DialogModalId: 'AuditSettingEditDialogID',
            refresh: false
        }
    },

    watch: {
        VisibleDialog(newVal) {
            if (newVal) {
                this.refresh = false;
                this.$bvModal.show(this.DialogModalId);
            }
        }
    },

    computed : {
        moduleName() {
            return this.$t('AuditList.Module') + ": " + this.value?.moduleTrans ?? '';
        },

        isAuthentication() {
            return this.value?.moduleCapitalized == 'Authentication';
        },

        isViewVisible() {
            const viewVisible = ['Patient Info', 'Clinical Notes', 'Group Notes'];
            return viewVisible.indexOf(this.value?.moduleCapitalized) != -1;
        }
    },

    methods : {
        emitEventCancel() {
            this.$bvModal.hide(this.DialogModalId);
            this.$emit('close', this.refresh);
        },

        emitEventOK() {
            this.refresh = true;
        }
    }
}
</script>